window.subscriptions = {
    subscriptionId: null,

    setSubscriptionId: function(subscriptionId) {
        window.subscriptions.subscriptionId = subscriptionId;
    },

    skipAMonth: {
        skip: async function () {
            if (!window.subscriptions.subscriptionId) {
                console.error("Could not skip a month, subscription ID is not set");
                return false;
            }

            const responseJson = await window.utils.request.post(`/wp-json/klira/subscription/${window.subscriptions.subscriptionId}/skip_a_month`)

            return JSON.parse(responseJson);
        }
    },

    retention: {
        appId: null,
        addonId: null,
        cbSubscriptionId: null,


        getCustomerSubscription() {
            if (!window.subscriptions.retention.cbSubscriptionId) {
                return null;
            }

            let selectedSubscription = null;

            window.customer.subscriptions.objects.forEach(function(kliraSubscription) {
                kliraSubscription.items.forEach(function (subscription) {
                    if (subscription.master_subscription_id === window.subscriptions.retention.cbSubscriptionId) {
                        selectedSubscription = subscription;
                    }
                })
            });

            return selectedSubscription;
        },
        setAppId(appId) {
            window.subscriptions.retention.appId = appId;
        },
        setAddonId: function (addonId) {
            window.subscriptions.retention.addonId = addonId;
        },
        setCbSubscriptionId: function(cbSubscriptionId) {
            window.subscriptions.retention.cbSubscriptionId = cbSubscriptionId;
        },
        run: function() {
            if (!window.Brightback || typeof window.Brightback === "undefined") {
                console.error("BrightBack not found, cannot launch retention");
                return;
            } else if (!window.subscriptions.retention.appId) {
                console.error("Retention App ID not set, cannot launch retention");
                return;
            } else if (!window.subscriptions.retention.addonId || !window.subscriptions.retention.cbSubscriptionId) {
                console.error("Addon ID and/or CB Subscription ID is not set, cannot launch retention");
                return;
            }

            console.log('Launching retention flow');

            let subscription = window.subscriptions.retention.getCustomerSubscription();

            if (!subscription) {
                console.error('Could not retrieve selected subscription');
                return;
            }

            return window.Brightback.handleDataPromise({
                app_id: window.subscriptions.retention.appId,
                email: window.customer.email,
                subscription_id: subscription.master_subscription_id,
                account: {
                    internal_id: window.customer.id,
                },
                custom: {
                    subscription_type: subscription.type,
                    subscription_term: subscription.term
                }
            });
        },
    },
}